module.exports = __webpack_public_path__ + "static/moonlitNightFirstDevelopmentArranged-6cf10619677236525eb62e30fd4f8bf4.mp3";